module.exports = __webpack_public_path__ + "img/shield-disabled.cfee0fe7.svg";